import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            navigate('/confirmBooking');
        }
        
        setValidated(true);
    };

    return (
        <div className='my-5'>
            <div className='form-container mx-auto'>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <h2 className='text-center mt-2 mb-4'>Please fill this booking form</h2>
                    
                    <Form.Group className="mb-3" controlId="formBasicName">
                        <Form.Label>Your name</Form.Label>
                        <Form.Control required type="text" placeholder="Enter your full name" />
                        <Form.Control.Feedback type="invalid">Please enter your name.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPhone">
                        <Form.Label>Your Phone Number</Form.Label>
                        <Form.Control required type="text" placeholder="Enter your phone number" />
                        <Form.Control.Feedback type="invalid">Please enter a valid phone number.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control required type="email" placeholder="Enter email" />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">Please enter a valid email.</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicDate">
                        <Form.Label>Enter Booking Date</Form.Label>
                        <Form.Control required type="date" placeholder="Enter Booking Date" />
                        <Form.Control.Feedback type="invalid">Please select a booking date.</Form.Control.Feedback>
                    </Form.Group>

                    <div className="pt-2">
                        <Button variant="primary" type="submit">
                            Confirm Booking
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default Checkout;
